// extracted by mini-css-extract-plugin
export default {"switcherButton":"_9929g","active":"u4hliz","tooltip":"YlKtvs"};